(function () {
  const cards = document.querySelectorAll('[data-card-price-wrapper]');
  if (!cards.length) return;

  const moneyFormat = window.Shopify?.money_format || '₹{{amount}}';

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const noDecimals = Math.round(cents / 100).toString();
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  }

  function updateAllCards() {
    cards.forEach(wrapper => {
      const originalPrice = parseInt(wrapper.dataset.originalPrice);

      // ✅ Each card carries its own discount % via data attribute set in Liquid
      const pct = parseInt(wrapper.dataset.discountPercent || '0');

      const priceEl = wrapper.querySelector('[data-auto-discount-price]');
      const compareEl = wrapper.querySelector('[data-auto-discount-compare]');
      const inlineBadge = wrapper.querySelector('[data-auto-discount-badge]');
      const priceDiv = wrapper.querySelector('.price');

      if (pct > 0) {
        const finalPrice = Math.round(originalPrice * (1 - pct / 100));

        if (priceDiv) {
          priceDiv.classList.add('price--on-sale');
          priceDiv.classList.add('price--show-badge');
        }
        if (priceEl) priceEl.innerHTML = formatMoney(finalPrice);
        if (compareEl) compareEl.innerHTML = formatMoney(originalPrice);
        if (inlineBadge) {
          inlineBadge.textContent = `${pct}% Off`;
          inlineBadge.style.display = 'inline-block';
        }
      } else {
        if (priceDiv) {
          priceDiv.classList.remove('price--on-sale');
          priceDiv.classList.remove('price--show-badge');
        }
        if (priceEl) priceEl.innerHTML = formatMoney(originalPrice);
        if (compareEl) compareEl.innerHTML = formatMoney(originalPrice);
        if (inlineBadge) inlineBadge.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllCards);
  } else {
    updateAllCards();
  }

})();